import {
  type EventAttributeSet,
  EventAttributeType,
} from "../../EventAttributeSet";

import { type AttributeValue } from "@/schemas/attribute/AttributeSet";
import { attributeListToMap } from "@/utils/attributes";

export enum EventCategory {
  PARADE = "PARADE",
  BAR = "BAR",
  CLUB = "CLUB",
  SHOW = "SHOW",
}

const EVENT_CATEGORY_OPTIONS: ReadonlyArray<AttributeValue> = [
  { id: EventCategory.PARADE, label: "Parade", iconLabel: "🥁" },
  { id: EventCategory.BAR, label: "Bar", iconLabel: "🍸" },
  { id: EventCategory.CLUB, label: "Club", iconLabel: "🕺" },
];

export const EventCategorySet: EventAttributeSet = {
  id: EventAttributeType.CATEGORY,
  isMultiSelect: true,
  map: attributeListToMap(EVENT_CATEGORY_OPTIONS),
} as const;
